<template>
  <va-card>
    <div class="video__chat" :class="{'video__chat__preview': !videoCallStarted}">
      <div class="video__container">
        <video v-if="videoCallStarted" ref="otherVideo" id="remoteVideo" class="video__partner" autoplay></video>
        <video ref="myVideo" id="localVideo" class="video__myself" autoplay muted></video>
        <div class="video__controls">
          <div class="item item--audio" @click="constraints.audio = !constraints.audio">
            <i v-if="constraints.audio" class="fa fa-microphone"></i>
            <i v-else class="fa fa-microphone-slash"></i>
          </div>
          <div class="item item--video" @click="constraints.video = !constraints.video">
            <i v-if="constraints.video" class="va-icon material-icons">videocam</i>
            <i v-else class="va-icon material-icons">videocam_off</i>
          </div>
          <div class="item item--network">
            <i v-if="constraints.audio" class="fa fa-signal"></i>
            <i v-else class="fa fa-signal"></i>
          </div>
        </div>
      </div>
      <div class="video__chat__join">
        <button @click="initCall" :disabled="true" class="btn btn-primary btn-micro">{{$t('evocall.requests.call')}}</button>
      </div>
    </div>
  </va-card>
</template>
<script>
import Peer from 'simple-peer'
export default {
  props: {
    request: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      pc: null,
      remoteStream: null,
      localStream: null,
      localId: null,
      remoteId: null,
      videoCallStarted: false,
      constraints: {
        audio: true,
        video: true,
        network: true
      }
    }
  },
  created () {
    this.initLocalVideo()
  },
  methods: {
    initLocalVideo: function () {
      this.getUserMedia()
        .then(() => this.getAudioVideoInfo())
        .then(() => this.getNetworkInfo())
    },
    initCall: function () {
      this.$socket.emit('call', { room: this.currentRoom })
    },
    endCall: function () {
      this.$socket.emit('leave', { room: this.currentRoom })
      this.pc.destroy()
      if (this.localStream) {
        this.localStream.getTracks().forEach(track => track.stop())
      }
      if (this.remoteStream) {
        this.remoteStream.getTracks().forEach(track => track.stop())
      }
      this.videoCallStarted = false
    },
    getUserMedia () {
      return new Promise((resolve, reject) => {
        if ('mediaDevices' in navigator) {
          navigator.mediaDevices.getUserMedia(this.constraints)
            .then(stream => {
              this.$refs.myVideo.srcObject = stream
              this.localStream = stream
              resolve()
            }).catch(error => {
              console.log('error', error)
              reject(error)
            })
        }
      })
    },
    createPeer: function () {
      this.pc = new Peer({
        initiator: true,
        trickle: false,
        stream: this.localStream
      })
      console.log(`Peer created`)
      this.pc.on('signal', (data) => {
        this.localId = JSON.stringify(data)
        if (this.localId !== '{"renegotiate":true}') {
          let message = JSON.stringify(data)
          let room = this.currentRoom
          this.sendMessage({ room, message })
        }
      })

      /**
       * Stream
       */
      this.pc.on('stream', (stream) => {
        this.remoteStream = stream
        this.$refs.otherVideo.srcObject = stream
      })
    },
    sendMessage: function ({ room, message }) {
      this.$socket.emit('message', { room, message })
    },
    getAudioVideoInfo () {
      console.log('get audio and video info')
      const video = this.localStream.getVideoTracks()
      const audio = this.localStream.getAudioTracks()

      if (video.length > 0) console.log(`Using video device: ${video[0].label}`)
      if (audio.length > 0) console.log(`Using audio device: ${audio[0].label}`)
    },
    getNetworkInfo: function () {
      let connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection
      this.constraints.network = connection !== null
    }
  },
  watch: {
    'constraints.audio': function (audioOption) {
      let audioTracks = this.localStream.getAudioTracks()
      // audioTracks.removeTrack([0])
      audioTracks.forEach(track => {
        track.enabled = audioOption
        console.log('track', track)
      })
    },
    'constraints.video': function (videoOption) {
      let videoTracks = this.localStream.getVideoTracks()
      videoTracks.forEach(track => {
        track.enabled = videoOption
      })
    }
  },
  sockets: {
    newCallReceived: function ({ appointment, user }) {
      console.log(`A new call atempt was received by ${user.name}`)
    },
    ready: function () {
      console.log('A video call is about to start...')
      this.videoCallStarted = true
      this.createPeer()
    },
    // Update this socket event to signal?
    message: function (message) {
      console.log(`Received message: ${message}`)
      this.remoteId = message
      this.pc.signal(JSON.parse(this.remoteId))
    },
    callEnded: function () {
      console.log('Video call has ended')
      this.videoCallStarted = false
      this.endCall()
    }
  },
}
</script>
<style lang="scss">
@mixin for-desktop {
  @media (min-width: 599px) {
    @content;
  }
}

.video__chat {
  // height: 550px;
  // height: 750px;

  &.video__chat__preview {
    display: flex;
    flex-direction: column;
    // justify-content: center;
    align-items: center;

    & .video__container {
      display: flex;
      flex-direction: column;
      // position: relative;
      width: 100%;
      // height: 65%;
      //top: 0;
      //left: 0;
      border-radius: 10px;
      overflow: hidden;
      @include for-desktop {
        width: 75%;
      }
      & .video__myself {
        // position: relative;
        // top: 0;
        // left: 0;
        // width: 100%;
        // height: 100%;
        // border-radius: 15px;
        height: 250px;
        max-height: 400px;
        @include for-desktop {
          height: inherit;
          max-height: none;
        }
      }

      & .video__controls {
        // position: absolute;
        // top: 0px;
        // right: -10px;
        // height: 100%;
        margin-top: 1rem;
        display: flex;
        // flex-direction: column;
        // flex-direction: column;
        justify-content: center;
        @include for-desktop {
          margin-top: 0rem;
        }
        & .item {
          display: flex;
          align-items: center;
          justify-content: center;
          background-color: #29c4a9;
          color: white;
          padding: 10px;
          width: 45px;
          height: 45px;
          font-size: 1rem;
          border-radius: 50%;
          margin-right: 1rem;
          border: 0.4rem solid white;
          @include for-desktop {
            width: 60px;
            height: 60px;
            font-size: 1.4rem;
          }

          &.item--audio {
            background-color: #7F62F6;
          }
          &.item--video {
            background-color: #28A5FC;
          }
          &.item--network {
            background-color: #1ED78D;
          }

          &:hover {
            cursor: pointer;
          }

          &.item__action--turn-off {
            background-color: rgb(236, 69, 69);
          }
          &.item__action--call {
            background-color: #29c4a9;
          }
        }
      }
    }

    & .video__chat__join {
      margin-top: 1.5rem;
      display: flex;
      justify-content: center;
      & button {
        border-radius: 30px;
        font-size: 1.2rem;
      }
    }
  }
}
</style>
